import { render, staticRenderFns } from "./classInfo.vue?vue&type=template&id=23afb018&scoped=true&"
import script from "./classInfo.vue?vue&type=script&lang=js&"
export * from "./classInfo.vue?vue&type=script&lang=js&"
import style0 from "./classInfo.vue?vue&type=style&index=0&id=23afb018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afb018",
  null
  
)

export default component.exports